// The PR the cockpit was deep-linked from (the "Translation review" check's
// `?pr=`). Set once by the worklist on mount; read by the sign-off posters so
// the server can flip that PR's check green when its last blocker clears,
// without a re-push. null = the cockpit was opened directly (whole-scope), so
// there's no PR check to flip. Module-level (not the review store) because the
// posters are plain functions outside React.
let currentPr: number | null = null

export function setReviewPr(pr: number | null): void {
  currentPr = pr
}

export function getReviewPr(): number | null {
  return currentPr
}
